import { memo, useState } from 'react'
import {
  Button,
  Heading,
  ModalBody,
  ModalHeader,
  useDisclosure,
  Modal,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
} from '@chakra-ui/react'

import { PhotographicCamera } from 'components/icons'
import CameraWebcamSwitcher from './components/CameraWebcamWithPhoto'
import SavePhotoFromWebcam from './components/SavePhotoFromWebcam'

type Props = {
  isDisabled?: boolean
}

function UploadTakeAPicture({ isDisabled }: Props) {
  const [photo, setPhoto] = useState<string | null>(null)

  const { onClose, onOpen, isOpen } = useDisclosure()

  return (
    <>
      <Button isDisabled={isDisabled} width="100%" variant="outline" leftIcon={<PhotographicCamera />} onClick={onOpen}>
        Tirar foto
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="md">
        <ModalOverlay />

        <ModalContent rounded="md" width="98%">
          <ModalCloseButton />

          <ModalHeader roundedTop="md">
            <Heading size="md">Tirar foto</Heading>
          </ModalHeader>

          <ModalBody p={2} m={0}>
            {photo === null ? (
              <CameraWebcamSwitcher setPhoto={setPhoto} />
            ) : (
              <SavePhotoFromWebcam photo={photo} setPhoto={setPhoto} onClose={onClose} />
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default memo(UploadTakeAPicture)
